import { assessmentModelModule } from '../../../../shared/app/models/assessment';

export const assessmentsServiceModule = angular
  .module('Q.services.assessments-service', [assessmentModelModule])

  .factory('assessmentsService', function (Assessment) {
    const defaultIncludes = ['team', 'team.customer'];

    return {
      find,
      findWithChallenges,
    };

    function _find(id, params) {
      params.includes = [].concat(params.includes || [], defaultIncludes);
      return Assessment.fetch(id, { params });
    }

    function find(id) {
      return _find(id);
    }

    function findWithChallenges(id, params) {
      return _find(
        id,
        angular.merge(params, {
          includes: 'challenge_items.challenge',
        }),
      );
    }
  });
